(function () {
  /** 使用方式：
    * <custom-select class="custom-select" active-value="当前选择的值">
    *   <div class="custom-select-label" data-custom-select-label>当前值对应显示文本</div>
    *   <span class="arrow-out">
    *     {% render 'icons', name: 'dropdown-arrow' %}
    *   </span>
    *   <div class="custom-select-options" data-custom-select-options>
    *     {%- for 列表项 in 列表 -%}
    *       <custom-select-option class="custom-select-option" value="列表项的值">
    *         列表项的值对应的显示文本
    *       </custom-select-option>
    *     {%- endfor -%}
    *   </div>
    *   <select>可选，适配原生标签</select>
    * </custom-select>
   */
  class CustomSelect extends HTMLElement {
    static get observedAttributes() {
      return ['active-value']
    }

    constructor() {
      super();
      this.optionElements = this.querySelectorAll('custom-select-option');
      this.selectLabel = this.querySelector("[data-custom-select-label]");
      this.value = this.getAttribute("active-value");

      // 适配原生 select
      this.selectElement = this.querySelector("select");
    }

    connectedCallback() {
      this.render(this.value);
      this.initEvent();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.flipArrow.bind(this))
      // this.removeEventListener('blur', this.blurWrapper.bind(this))

      this.optionElements
        .forEach((item, index) => {
          item.removeEventListener('click', this.change.bind(this, item.getAttribute("value")));
        });
    }

    attributeChangedCallback(attr, oldVal, newVal) {
      const attribute = attr.toLowerCase()
      if (attribute === 'active-value') {
        const optionElement = this.querySelector(`custom-select-option[value="${newVal}"]`);
        const optionLabel = optionElement.innerHTML;
        this.selectLabel.innerHTML = optionLabel;
        this.value = newVal;
      }
    }

    initEvent() {
      document.addEventListener("click", (e) => {
        this.hideList();
      });
      this.addEventListener('click', this.flipArrow.bind(this));
      this.optionElements
        .forEach((item, index) => {
          item.addEventListener('click', this.change.bind(this, item.getAttribute("value")));
        });
    }

    change(value) {
      this.render(value);

      let changeInfo = {
        detail: {
          value: value,
          label: this.optionLabel
        },
        bubbles: true
      }
      let changeEvent = new CustomEvent('change', changeInfo)
      this.dispatchEvent(changeEvent);

      if (this.selectElement) {
        this.selectElement.value = value;
        this.selectElement.dispatchEvent(new CustomEvent('change'));
      }
    }

    flipArrow(e) {
      const other = document.querySelector("custom-select.active");
      if (other && other != this) {
        other.hideList();
      }
      if (!this._arrowFlip) {
        this.showList()
      } else {
        this.hideList()
      }
      e.stopPropagation();
    }

    showList() {
      this._arrowFlip = true
      this.classList.add("active");
    }

    hideList() {
      this._arrowFlip = false
      this.classList.remove("active");
    }

    blurWrapper() {
      this.addEventListener('blur', (event) => {
        event.stopPropagation()
        this.hideList()
      })
    }

    render(value) {
      const optionElement = this.querySelector(`custom-select-option[value="${value}"]`);
      const optionLabel = optionElement.innerHTML;
      this.selectLabel.innerHTML = optionLabel;
      this.value = value;
      this.querySelector("[checked]")?.removeAttribute("checked");
      optionElement.setAttribute("checked", "");
    }
  }

  const FrozenCustomSelect = Object.freeze(CustomSelect);
  customElements.define('custom-select', FrozenCustomSelect);
})()
